import { formatLog } from "./logging";
import { isBrowser } from "./browser";

export interface InteractionType {
    id: number;
    dt: number;
    app: boolean;
}

/**
 * Retrieves the entire interaction history from local storage.
 *
 * @returns {InteractionType[]} - The interaction history array.
 */
export const getInteractionHistory = (): InteractionType[] => {
    if (!isBrowser()) return [];
    try {
        const history = localStorage.getItem("jobInteractionHistory");
        if (!history) return [];
        const result = JSON.parse(history);
        if (Array.isArray(result)) return result;
        // we are malformed so kill this history
        window.localStorage.removeItem("jobInteractionHistory");
        return [];
    } catch (error) {
        const msg = "Job-Renderer was unable to parse the interactions from local storage.";
        console.error(msg, JSON.stringify(formatLog({ error })));
        return [];
    }
};

/**
 * Retrieves the most recent interaction for a specific job ID.
 *
 * @param {number} id - The Job ID of the event to retrieve.
 * @returns {InteractionType | null} - The event object if found, otherwise null.
 */
export const getJobLastInteraction = (id: number): InteractionType | null => getInteractionHistory()
    .find((x: InteractionType) => x.id === id) ?? null;
